import { Observable } from "rxjs";
import { Product } from "../domain/models";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export abstract class ProductRepository {
  abstract getProducts(): Observable<Product[]>;
}
